<template>
  <vx-card no-shadow :style="{ 'pointer-events': __isDisabledSites() ? 'none' : 'auto' }">

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_ethical_trading_policy" name="is_ethical_trading_policy" rules="" v-slot="{ errors }">
              <small class="label">6.1 Do you have an ethical trading policy?</small>
              <vs-switch v-model="form.is_ethical_trading_policy" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_ethical_trading_policy" vid="ethical_trading_policy" name="ethical_trading_policy" rules="" v-slot="{ errors }">
              <small class="label">Please attach a copy (file)</small>
              <a target="_blank" v-if="form.ethical_trading_policy" class="float-right" :href="form.ethical_trading_policy">view file</a>
              <vs-input @change="onUploadPolicyFile($event)" type="file" name="ethical_trading_policy" class="w-full" />    <!-- enviromental_policy_file -->
              <span v-if="formUploadRequired" class="text-danger text-sm">This field is required</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_ethical_trading_initiative" name="is_ethical_trading_initiative" rules="" v-slot="{ errors }">
              <small class="label">6.2 Are you aware of the Ethical Trading Initiative (ETI) and do you attempt to follow its codes of labour practice?</small>
              <vs-switch v-model="form.is_ethical_trading_initiative" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_ethical_trading_initiative" vid="is_ethical_trading_initiative_text" name="is_ethical_trading_initiative_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_ethical_trading_initiative_text" class="w-full" v-model="form.is_ethical_trading_initiative_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_assessing_supplier" name="is_assessing_supplier" rules="" v-slot="{ errors }">
              <small class="label">6.3 Do you have a programme aimed at assessing your suppliers against the ETI ‘base code’?</small>
              <vs-switch v-model="form.is_assessing_supplier" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_assessing_supplier" vid="is_assessing_supplier_text" name="is_assessing_supplier_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input type="text" name="is_assessing_supplier_text" class="w-full" v-model="form.is_assessing_supplier_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>



        <div class="flex flex-wrap items-center justify-end" v-can="'edit-site'">
          <vs-button v-if="status.is_supplier_manufacture_site_ethical_complete === 1"  button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4">Save and Change</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRepository = RepositoryFactory.get('supplier');
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: "SupplierManufacturingEnvironmentDetails",
    data() {
      return {
        form: {
          is_ethical_trading_policy: false,
          is_ethical_trading_initiative: false,
          is_assessing_supplier: false
        },
        id: null,
        status: {},
        formUploadRequired: false
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_supplier_manufacture_site_ethical_complete === 1 ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        if (this.form.is_ethical_trading_policy && !this.form.ethical_trading_policy) {
          this.formUploadRequired = true
        } else {
          this.$vs.loading()
          try {
            const data= (await SupplierManufactureRepository.UpdateManufactureEthicalDetails(this.id, this.form))
            this.showSuccessMessage('Manufacture Ethical Details Updated!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }
      },
      async onClickCreate() {
        if (this.form.is_ethical_trading_policy && !this.form.ethical_trading_policy) {
          this.formUploadRequired = true
        } else {
          this.$vs.loading()
          try {
            const data= (await SupplierManufactureRepository.CreateManufactureEthicalDetails(this.form))
            this.showSuccessMessage('Manufacture Ethical Details Created!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureEthicalDetails(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureSiteStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
      async onUploadPolicyFile(event, model_name) {
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.ethical_trading_policy = (await SupplierRepository.uploadFile(formData)).data.data.file
          this.formUploadRequired = false
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_manufacture_site_id =  this.id
      await this.loadStatus()
      if (this.status.is_supplier_manufacture_site_ethical_complete === 1 ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
